var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close 1",
    clipPath: "url(#clip0_1430_559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3168 3.61577L12.4298 1.72949L8.03762 6.12235L3.64475 1.72949L1.75781 3.61577L6.15067 8.00863L1.75781 12.4015L3.64475 14.2878L8.03762 9.89491L12.4298 14.2878L14.3168 12.4015L9.92389 8.00863L14.3168 3.61577Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1430_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.008,
    height: 16.008,
    fill: "white",
    transform: "translate(0.00390625 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/close-1.5b077398d0c3332af49d2d3ab2abba61.svg";
export { ForwardRef as ReactComponent };